import { FontEntry } from '../../types/font'

export const raleway: FontEntry = {
  displayName: 'Raleway',
  weights: {},
  variables: {
    normal: {
      file: 'Raleway-VariableFont_wght',
      extension: 'ttf',
      format: 'truetype',
      weightRange: [100, 900]
    },
    italic: {
      file: 'Raleway-Italic-VariableFont_wght',
      extension: 'ttf',
      format: 'truetype',
      weightRange: [100, 900]
    }
  }
}
